var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('vue-headful',{attrs:{"title":_vm.componentConfig.branding.title('Manage Users')}}),_c('organizationUsers',{attrs:{"organization-id":_vm.organizationIdToRestrictUsersTo,"items-per-page":"25","full-table":"true","can-update":_vm.can.update.default}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }